import { render, staticRenderFns } from "./PaymentReceivable.vue?vue&type=template&id=400705f7&scoped=true"
import script from "./PaymentReceivable.vue?vue&type=script&lang=js"
export * from "./PaymentReceivable.vue?vue&type=script&lang=js"
import style0 from "./PaymentReceivable.vue?vue&type=style&index=0&id=400705f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400705f7",
  null
  
)

export default component.exports